import React from 'react';

function BetLoader() {
    return (
        <div className="ticket-detail-bet-wrap loader">
            <div className="bet-header">
                <div className="bet-header-status-icon">
                    <div className="ticket-state-badge status-badge " />
                    <div className="ticket-detail-ticket-state">
                        <div className="ticket-state" />
                    </div>
                </div>
                <div className="ticket-detail-bet">
                    <div className="ticket-detail-bet-row ticket-detail-bet-opponents">
                        <div className="match-header-icon sport-icon-mini" />
                        <div className="home-loader wave-animation" />
                    </div>

                    <div className="ticket-detail-bet-row ticket-detail-bet-market wave-animation" />

                    <div className="ticket-detail-bet-row ticket-detail-bet-other-info">
                        <span className="bet-loader wave-animation" />
                    </div>

                    <div className="ticket-detail-bet-row ticket-detail-bet-other-info">
                        <span className="bet-loader wave-animation" />
                        <div className="bet-odds bet-loader wave-animation" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BetLoader;
